export function makeFieldsData (studentData, grades = false) {
  const fields = {}
  studentData.forEach(function(student) {
    if (student.student_exam_mark.length !== 0) {
      const markField = `enroll_mark[${student.id}][exam_mark_score]`
      const examMark = grades ? student.student_exam_mark[0].exam_mark_grade : student.student_exam_mark[0].exam_mark_score

      fields[markField] = examMark
    }
  })

  return fields
}
